import routes from "config/routing/routes"

export const getRoutingConfig = (companyName?: string) => {
  const items = []

  routes
    .filter(elt => elt.environments.includes(process.env.REACT_APP_STAGE))
    .forEach(category => {
      if (category.elements.length !== 0) {
        category.elements.forEach(elt => {
          if (elt.component !== undefined) {
            if (companyName && elt.onlyForCompanies.length > 0 && !elt.onlyForCompanies.includes(companyName)) {
              return
            }

            items.push({
              path: elt.path,
              exact: elt.exact,
              component: elt.component,
              icon: elt.icon,
              inSidebar: elt.inSidebar,
              label: elt.label,
              authorizedRoles: elt.authorizedRoles || category.authorizedRoles,
            })
          }

          if (elt.children.length !== 0) {
            elt.children.forEach(subelt => {
              if (subelt.component !== undefined) {
                items.push({
                  path: subelt.path,
                  exact: subelt.exact,
                  component: subelt.component,
                  icon: subelt.icon,
                  inSidebar: subelt.inSidebar,
                  label: subelt.label,
                  authorizedRoles: subelt.authorizedRoles || elt.authorizedRoles || category.authorizedRoles,
                })
              }
            })
          }
        })
      }
    })
  return items
}

export const getSidebarConfig = (companyName?: string) =>
  routes.map(category => ({
    ...category,
    elements: category.elements.filter(elt =>
      companyName ? elt.onlyForCompanies.length === 0 || elt.onlyForCompanies.includes(companyName) : true,
    ),
  }))
